import { PublicLinkLocationType } from "@clockwise/schema";
import { Typography } from "@material-ui/core";
import { MeetingDuration } from "@ui/meeting-duration";
import { MEETING_LOCATION_DETAILS } from "@ui/scheduling-confirmation/event-summary";
import React from "react";
import { MeetingTitle } from "./MeetingTitle";

type Props = {
  owner: {
    email?: string | null;
    givenName: string | null;
    familyName: string | null;
    externalImageUrl: string | null;
  };
  isOwner: boolean;
  meetingSettings: {
    name: string;
    description: string | null;
    durationMinutes: number;
    locationType: PublicLinkLocationType;
  };
};

export function MeetingDetails({
  owner,
  isOwner,
  meetingSettings: { name: meetingName, description, durationMinutes: duration, locationType },
}: Props) {
  const meetingLocation = locationType && MEETING_LOCATION_DETAILS[locationType];

  return (
    <div className="cw-flex cw-flex-col cw-gap-4" cw-id="link-meeting-details">
      <div
        className="cw-flex cw-flex-col cw-gap-4 cw-font-brand cw-text-slate-standard"
        key="avatar-container"
      >
        <MeetingTitle owner={owner} isOwner={isOwner} />
        <div
          title={meetingName}
          className="cw-text-24 cw-text-ellipsis cw-font-bold cw-leading-tight cw-text-dusk-darker cw-max-w-xs xs:cw-max-w-[98%] xs:cw-line-clamp-2"
          cw-id="link-meeting-name"
          aria-label="meeting name"
        >
          {meetingName}
        </div>
      </div>
      <div className="cw-font-body cw-flex cw-flex-wrap cw-items-center cw-text-slate-standard cw-font-bold cw-text-14 cw-gap-x-5 cw-gap-y-2">
        <MeetingDuration key="duration" minutes={duration} />
        {meetingLocation && (
          <div className="cw-flex cw-items-center">
            <span className="cw-mb-[-3px]" cw-id="link-location-icon">
              {meetingLocation.locationIcon}
            </span>
            <span className="cw-ml-2" cw-id="link-location-type" aria-label="meeting location">
              {meetingLocation.locationName}
            </span>
          </div>
        )}
      </div>
      {description && (
        <Typography
          variant="body1"
          className="cw-font-body cw-text-slate-standard cw-text-14 cw-max-w-[96%] cw-line-clamp-14 cw-text-ellipsis xs:cw-line-clamp-none xs:cw-max-h-[250px] xs:cw-overflow-auto"
          cw-id="link-description"
        >
          {description}
        </Typography>
      )}
    </div>
  );
}
